var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.computedUrl,"target":"_blank"}},[_c('BaseIcon',{attrs:{"icon":_vm.icon,"small":"","tooltipText":_vm.tooltipText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }